import { render, staticRenderFns } from "./ApprovalApproveModal.vue?vue&type=template&id=8da10600"
import script from "./ApprovalApproveModal.vue?vue&type=script&lang=ts"
export * from "./ApprovalApproveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports